<template>
    <div class="selector">
        <p
            class="selector-title"
            tabindex="0"
            readonly="readonly"
            ref="selector-input"
            @blur="handleBlur"
            @click="handleFocus"
        >
            <span>请添加车型</span>
            <i class="el-icon-arrow-down" :class="{actived: selectorShow}"></i>
        </p>
        <div
            class="container"
            v-if="selectorShow"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"
        >
            <div class="bread-title">
                <p class="p" @click="handleSwitch(0)">品牌</p>
                <i class="el-icon-arrow-right"></i>
                <template v-if="selectBrandStatus">
                    <p class="p" @click="handleSwitch(1)">车系</p>
                    <i class="el-icon-arrow-right"></i>
                </template>
                <template v-if="selectSeriesStatus">
                    <p class="p">车型</p>
                </template>
            </div>
            <div class="content" :style="{height: brandHeight}">
                <div :style="{
                    left: -currentTab * 362 + 'px',
                    height: '100%'
                }">
                    <div class="content-brand">
                        <div class="anchor-scrollbar-hidden">
                            <c-anchor
                                :params="letterList"
                                :duration="500"
                                :top="0"
                                :container="'.brand-text'"
                                anchor-class=".selector-anchor"
                                ref="anchor"
                            />
                        </div>
                        <div class="brand-text"
                        >
                            <div
                                v-for="(item, index) in brandList"
                                class="selector-anchor"
                                :data-letter="item.letterName"
                                :key="item.letterName"
                                data-type="anchor"
                                :data-anchor="item.letterName + '-' + index"
                            >
                                <div class="brand letter"
                                    :style="{height: LETTER_HEIGHT + 'px', lineHeight: LETTER_HEIGHT + 'px'}"
                                >{{item.letterName}}</div>
                                <p
                                    v-for="brand in item.brandList"
                                    class="brand text"
                                    :class="{isActive: selectBrand === brand}"
                                    :style="{height: BRAND_HEIGHT + 'px', lineHeight: BRAND_HEIGHT + 'px'}"
                                    :key="brand.code"
                                    @click="handleClickBrandText(brand)"
                                >
                                    <img src="@/assets/images/bitmap-small.png" v-real-src="brand.logo">
                                    {{brand.name}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="brand-series">
                        <div class="loading" v-if="seriesRequestStatus">
                            <i class="el-icon-loading" />
                            加载中
                        </div>
                        <div class="no-data" v-else-if="!seriesList || !seriesList.length">
                            暂无数据
                        </div>
                        <template v-else>
                            <template
                                v-for="(item, index) in seriesList"
                            >
                                <div
                                    v-for="(series, idx) in (item.list || [])"
                                    :key="item.groupName"
                                >
                                    <div
                                        class="series letter"
                                        :style="{height: LETTER_HEIGHT + 'px', lineHeight: LETTER_HEIGHT + 'px'}"
                                    >
                                        {{series.groupName}}
                                        <span v-if="item.name && item.name == '停售/未售'">（停售）</span>
                                    </div>
                                    <p
                                        v-for="(s, i) in (series.groupList || [])"
                                        class="series text"
                                        :class="{isActive: selectSeries === s}"
                                        :key="s.id"
                                        @click="handleClickSeriesText(s)"
                                    >
                                        {{s.name}}
                                    </p>
                                </div>
                            </template>
                        </template>
                    </div>
                    <div class="content-model">
                        <div class="loading" v-if="modelRequestStatus">
                            <i class="el-icon-loading" />
                            加载中
                        </div>
                        <div class="no-data" v-else-if="!modelList || !modelList.length">
                            暂无数据
                        </div>
                        <template v-else>
                            <div
                                v-for="(model, idx) in modelList"
                                :key="model.groupName"
                            >
                                <div
                                    class="series letter"
                                    :style="{height: LETTER_HEIGHT + 'px', lineHeight: LETTER_HEIGHT + 'px'}"
                                >
                                    {{model.groupName}}
                                    <span v-if="model.sellStat && model.sellStat == 0">（停售）</span>
                                </div>
                                <p
                                    v-for="(m, i) in model.groupList"
                                    class="series text"
                                    :class="{'selected': selectModel.includes(m.id)}"
                                    :key="m.id"
                                    @click="handleClickModelText(m)"
                                >
                                    {{m.modelName}}
                                </p>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file 车型选择器
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import Anchor from 'components/anchor';

const LETTER_HEIGHT = 28;
const BRAND_HEIGHT = 54;

const REQUEST_STORE_SERIES = {};
const REQUEST_STORE_MODEL = {};

export default {
    components: {
        'c-anchor': Anchor
    },
    props: {
        selectModel: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            LETTER_HEIGHT,
            BRAND_HEIGHT,
            selectorShow: false,
            brandList: [],
            letterList: [],
            seriesList: [],
            modelList: [],
            seriesRequestStatus: true,
            modelRequestStatus: true,
            currentTab: 0,
            selectBrand: {},
            selectBrandStatus: false,
            selectSeries: {},
            selectSeriesStatus: false,
            selectModelStatus: false,
            isEnter: false
        };
    },
    computed: {
        brandHeight() {
            /**
             * 36 drawer title 高度
             * 20 drawer title marginBottom
             * 48 input 高度
             * 30 距离底部的高度
             * 46 title 高度
             */
            let docHeight = document.documentElement.clientHeight - 36 - 20 - 48 - 60 - 46;
            const realHeight = this.letterList.length * LETTER_HEIGHT;
            // 设置200为最低高度
            if (docHeight < 200) {
                docHeight = 200;
            }
            return Math.min(docHeight, realHeight) + 'px';
        }
    },
    created() {
        this.getBrand();

    },
    methods: {
        getBrand() {
            if (this.brandList && this.brandList.length) {
                return;
            }
            request(URLS.GETHOMEINFO)
                .then(res => {
                    /* eslint-disable fecs-camelcase */
                    const {brand_list = []} = res.Result;
                    const brandList = brand_list;
                    this.brandList = brandList;
                    /* eslint-enable fecs-camelcase */
                    this.letterList = brandList.map((v, i) => ({
                        id: `${v.letterName}-${i}`,
                        itemName: v.letterName
                    }));
                })
                .catch(err => {});
        },
        getSeriesByBrand(brandname, brandcode) {
            if (REQUEST_STORE_SERIES[brandcode]) {
                this.seriesList = REQUEST_STORE_SERIES[brandcode];
                return;
            }
            this.seriesRequestStatus = true;
            request(URLS.getSeriesByBrand, {
                brandname
            })
                .then(res => {
                    const {tabs} = res.Result;
                    REQUEST_STORE_SERIES[brandcode] = tabs;
                    this.seriesList = tabs;
                    this.seriesRequestStatus = false;
                })
                .catch(err => {});
        },
        getModel(seriesId, sellStat) {
            /* eslint-disable fecs-camelcase */
            return request(URLS.getSeriesModels, {
                series_id: seriesId,
                sell_stat: sellStat
            });
            /* eslint-enable fecs-camelcase */
        },
        getModelAll(seriesId) {
            if (REQUEST_STORE_MODEL[seriesId]) {
                this.modelList = REQUEST_STORE_MODEL[seriesId];
                return;
            }
            this.modelRequestStatus = true;
            Promise.all([
                this.getModel(seriesId, 1),
                this.getModel(seriesId, 0)
            ])
                .then(([val1, val2]) => {
                    const {models: models1 = {}} = val1.Result;
                    const {models: models2 = {}} = val2.Result;
                    const modelList = [
                        ...Object.keys(models1).map(v => ({
                            sellStat: 1,
                            groupName: v,
                            groupList: models1[v] || []
                        })),
                        ...Object.keys(models2).reverse().map(v => ({
                            sellStat: 0,
                            groupName: v,
                            groupList: models2[v] || []
                        }))
                    ];
                    this.modelList = modelList;
                    REQUEST_STORE_MODEL[seriesId] = modelList;
                    this.modelRequestStatus = false;
                })
                .catch(err => {});
        },
        handleClickBrandText(brand) {
            if (this.selectBrandStatus) {
                return;
            }
            this.selectBrandStatus = true;
            this.selectBrand = brand;
            this.currentTab = 1;
            this.getSeriesByBrand(brand.name, brand.code);
        },
        handleClickSeriesText(series) {
            if (this.selectSeriesStatus) {
                return;
            }
            this.selectSeriesStatus = true;
            this.selectSeries = series;
            this.currentTab = 2;
            this.getModelAll(series.id);
        },
        handleClickModelText(model) {
            if (this.selectModel.includes(model.id)) {
                return;
            }
            this.selectModelStatus = true;
            this.$emit('change', {
                modelName: `${this.selectSeries.name} ${model.modelName}`,
                id: model.id
            });
            this.$nextTick(() => {
                this.reset();
                this.selectorShow = false;
            });
        },
        handleSwitch(idx) {
            this.currentTab = idx;
            switch (idx) {
                // 重新选择品牌
                case 0: {
                    this.selectBrandStatus = false;
                    // this.selectBrand = {}; // 如果不需要保存结果，则打开
                    this.selectSeries = {};
                    this.seriesList = [];
                    // 不用添加break
                    // 如果从品牌开始的话，车系肯定也要重新
                }
                // 选择车系
                case 1: {
                    this.selectSeriesStatus = false;
                    this.modelList = [];
                    // this.selectSeries = {}; // 如果不需要保存结果，则打开
                }
            }
        },
        handleBlur() {
            if (this.isEnter) {
                return;
            }
            this.isEnter = false;
            this.selectorShow = false;
        },
        handleFocus() {
            if (this.selectorShow) {
                this.$refs['selector-input'].blur();
                return;
            }
            this.selectorShow = true;
        },
        handleMouseEnter() {
            this.isEnter = true;
        },
        handleMouseLeave() {
            this.isEnter = false;
        },
        reset() {
            this.currentTab = 0;
            this.selectBrand = {};
            this.selectBrandStatus = false;
            this.selectSeries = {};
            this.selectSeriesStatus = false;
            this.selectModelStatus = false;
        }
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;
@tabWidth: 362px;

.selector {
    position: relative;
    width: 362px;
    .selector-title {
        display: flex;
        align-items: center;
        padding: 0 20px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        outline: none;
        cursor: pointer;
        span {
            display: block;
            flex: 1;
        }
        i {
            transition: transform .1s linear;
            &.actived {
                transform: rotateZ(180deg);
            }
        }
    }
    .container {
        position: absolute;
        left: 0;
        top: 54px;
        box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .1);
        background: #FFFFFF;
        .content {
            position: relative;
            width: @tabWidth;
            overflow: hidden;
            > div {
                position: absolute;
                display: flex;
                width: 1086px;
                transition: left .2s linear;
            }
        }
        .content-brand {
            display: flex;
            height: 100%;
            width: @tabWidth;
        }
        .bread-title {
            display: flex;
            height: 46px;
            align-items: center;
            font-size: 16px;
            padding-left: 8px;
            user-select: none;
            .p {
                color: #333333;
                cursor: pointer;
            }
            i {
                margin: 0 4px;
            }
        }
        .brand-text {
            position: relative;
            overflow-y: scroll;
            flex: 1;
            height: 100%;
            color: #333333;
            border-left: 1px solid #EEEEEE;
            .brand {
                font-size: 16px;
                padding-left: 16px;
                &.text {
                    display: flex;
                    cursor: pointer;
                    align-items: center;
                    img {
                        width: 30px;
                        height: 30px;
                        margin-right: 22px;
                    }
                    &:hover {
                        color: @themeColor;
                        cursor: pointer;
                    }
                    &.isActive {
                        font-weight: 800;
                        color: @themeColor;
                    }
                }
                &.letter {
                    position: sticky;
                    font-size: 12px;
                    top: 0;
                    background: #f8f8f8;
                    cursor: default;
                }
            }
        }
        .brand-series {
            width: @tabWidth;
            height: 100%;
            overflow: scroll;
        }
        .series {
            font-size: 16px;
            padding-left: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &.text {
                height: 38px;
                line-height: 38px;
                &:hover {
                    color: @themeColor;
                    cursor: pointer;
                }
                &.isActive {
                    font-weight: 800;
                    color: @themeColor;
                }
                &.selected {
                    color: #999999;
                    cursor: not-allowed;
                }
            }
            &.letter {
                position: sticky;
                font-size: 12px;
                top: 0;
                background: #f8f8f8;
                cursor: default;
            }
        }
        .content-model {
            width: @tabWidth;
            height: 100%;
            overflow-y: scroll;
            overflow-x: hidden;
        }
    }
    .anchor-scrollbar-hidden {
        width: 28px;
        height: 100%;
        overflow: hidden;
    }
    /deep/ .anchor {
        position: relative;
        width: 43px;
        height: 100%;
        font-size: 14px;
        font-weight: 500;
        background: #ffffff;
        overflow-x: hidden;
        overflow-y: scroll;
        > div {
            width: 28px;
            text-align: center;
            height: 28px;
            line-height: 28px;
            cursor: pointer;
            &.anchorActive {
                color: #FFFFFF;
                background: @themeColor;
                font-weight: 500;
            }
        }
    }
}

.no-data,
.loading {
    width: 100%;
    margin-top: 40px;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #999999;
    i {
        margin-right: 8px;
    }
}
</style>
